export default __webpack_public_path__ + "static/media/other-accommodation.32dd49b8.svg";